'use strict';

import { animate, getVueTemplate } from '../../../_imports/utils/utils.common';
import MediaImage from '../../../vue/media-image.main.js';
import { renderPositionTitle } from '../../../members/_imports/person.common.js';

const animationExpand = 'slideDown';
const animationCollapse = 'slideUp';
const animationDuration = 400;
const animationEasing = 'easeInBack';

const expandArguments = {
    properties: animationExpand,
    options: {
        duration: animationDuration,
        easing: animationEasing
    }
};

const collapseArguments = {
    properties: animationCollapse,
    options: {
        duration: animationDuration,
        easing: animationEasing
    }
};

const speaker = {
    template: getVueTemplate('resource-speaker'),
    components: {
        MediaImage
    },
    props: {
        speaker: Object,
        activeSiblingTab: Object,
        includeCompanyNameInPositionTitle: Boolean
    },
    data() {
        return {
            isActive: false
        }
    },
    computed: {
        positionTitle() {
            return renderPositionTitle({
                person: this.speaker,
                includeCompanyName: this.includeCompanyNameInPositionTitle
            });
        }
    },
    methods: {
        toggleActive() {
            this.isActive = !this.isActive;
            this.$emit('active', this);
        },
        enter(element, done) {
            animate(element, expandArguments, {
                complete: () => {
                    return done;
                }
            });
        },
        leave(element, done) {
            animate(element, collapseArguments, {
                complete: () => {
                    return done;
                }
            });
        },
        shouldDisplayPremium() {
            return this.speaker.premium && this.speaker.shortDescription;
        }
    },
    watch: {
        activeSiblingTab(activeSibling) {
            this.isActive = activeSibling === this;
        }
    }
};

export default speaker;